<template>
    <footer class="footer">
        <div class="container-fluid">

            <!-- <div class="copyright text-center">
                with
                <i class="fa fa-heart heart"></i> by
                
            </div> -->
        </div>
    </footer>
</template>
<script>
    export default {}

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue